export class CatProductModel {
    public iCatProductId?: number;
    public vDescription?: string;
    public iBusinessLineId?: number;
    public iActiveId?: number;
    public vCreateUserId?: string;
    public dtCreateDate?: string;
    public vModifUserId?: string;
    public dtModifDate?: string;
}
